import React, { useState } from 'react';
import { TextField, Button, Box, Typography, CircularProgress, Paper, MenuItem } from '@mui/material';

const TemplateCreator = () => {
  const [tableName, setTableName] = useState('');
  const [fields, setFields] = useState('');
  const [loading, setLoading] = useState(false);
  const [stdout, setStdout] = useState('');
  const [stderr, setStderr] = useState('');
  const [message, setMessage] = useState('');
  const [fieldName, setFieldName] = useState('');
  const [fieldType, setFieldType] = useState('varchar(255)');

  // TODO: Ensure this message is only displayed in development mode

  const handleAddField = () => {
    const name = fieldName.trim();
    const type = fieldType.trim();
    if (!name || !type) return;
    const entry = `${name}:${type}`;
    setFields((prev) => (prev ? `${prev}, ${entry}` : entry));
    setFieldName('');
  };

  const handleSubmit = async () => {
    setLoading(true);
    setMessage('');
    setStdout('');
    setStderr('');

    try {
      const response = await fetch('/api/generate-template', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ table_name: tableName, fields }),
      });

      const data = await response.json();
      setMessage(data.message);
      setStdout(data.stdout || '');
      setStderr(data.stderr || '');
    } catch (error) {
      setMessage('Request failed.');
    const validationErrors = [];
    const fieldsList = fields.split(',');
    fieldsList.forEach(field => {
        const [name, type] = field.split(':');
        if (!name || !type) validationErrors.push(`Invalid field format: ${field}. Expected format is name:type.`);
    });
    if (validationErrors.length > 0) {
        setMessage(`Validation errors: ${validationErrors.join(', ')}`);
        setLoading(false);
        return;
    }
      setStderr(error.toString());
    }

    setLoading(false);
  };

  return (
    <Box p={4}>
      <Typography variant="h6" color="warning.main" gutterBottom>
        in development
      </Typography>
      
      <Typography variant="h5" gutterBottom>
        Template Creator
      </Typography>

      <TextField
        label="Table Name"
        value={tableName}
        onChange={(e) => setTableName(e.target.value)}
        fullWidth
        margin="normal"
      />

      <Box mt={1} display="flex" alignItems="center" gap={2}>
        <TextField
          label="Field Name"
          value={fieldName}
          onChange={(e) => setFieldName(e.target.value)}
          fullWidth
        />
        <TextField
          select
          label="Field Type"
          value={fieldType}
          onChange={(e) => setFieldType(e.target.value)}
          sx={{ minWidth: 200 }}
        >
          <MenuItem value="varchar(255)">varchar(255)</MenuItem>
          <MenuItem value="text">text</MenuItem>
          <MenuItem value="int">int</MenuItem>
          <MenuItem value="float">float</MenuItem>
          <MenuItem value="boolean">boolean</MenuItem>
          <MenuItem value="date">date</MenuItem>
          <MenuItem value="timestamp">timestamp</MenuItem>
        </TextField>
        <Button variant="outlined" onClick={handleAddField}>Add Field</Button>
      </Box>

      {fields && (
        <Box mt={2}>
          <Typography variant="subtitle2">Fields:</Typography>
          <Box component="ul" sx={{ pl: 3, m: 0 }}>
            {fields.split(',').map((f, i) => (
              <li key={i}>{f.trim()}</li>
            ))}
          </Box>
        </Box>
      )}

      <Box mt={2} display="flex" alignItems="center">
        <Button
          variant="contained"
          color="primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          Generate Template
        </Button>
        {loading && <CircularProgress size={24} sx={{ ml: 2 }} />}
      </Box>

      {message && (
        <Typography variant="subtitle1" mt={3}>
          {message}
        </Typography>
      )}

      {stdout && (
        <Paper elevation={2} sx={{ mt: 2, p: 2, backgroundColor: '#f4f4f4' }}>
          <Typography variant="subtitle2">Output:</Typography>
          <pre style={{ whiteSpace: 'pre-wrap' }}>{stdout}</pre>
        </Paper>
      )}

      {stderr && (
        <Paper elevation={2} sx={{ mt: 2, p: 2, backgroundColor: '#ffe6e6' }}>
          <Typography variant="subtitle2" color="error">Errors:</Typography>
          <pre style={{ whiteSpace: 'pre-wrap', color: 'red' }}>{stderr}</pre>
        </Paper>
      )}
    </Box>
  );
};

export default TemplateCreator;
